// extracted by mini-css-extract-plugin
module.exports = {"CopyTextInput":"CopyTextInput_CopyTextInput__1Q8Xx","Input":"CopyTextInput_Input__iHi-X","Tooltip":"CopyTextInput_Tooltip__3eyFV","Enabled":"CopyTextInput_Enabled__Yc7E-"};